import { CardHeader } from '@ps/isp-web-component-library';
import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import React from 'react';

import bgImage from '../../../../header-bg.png';
import PopularBetBuilderCount from '../PopularBetBuilderCount/PopularBetBuilderCount';

import styles from './PokerChipHeader.scss';
import Spade from './spade.svg';

interface Props {
  popularBetBuilderCount: number;
}

const PokerChipHeader: React.FC<Props> = ({ popularBetBuilderCount }) => {
  const isFlameVariantEnabled = useFeature(FeatureFlag.ISPExperimentPopularBetBuilderCount);
  return (
    <CardHeader className={styles.pokerChipCardHeader}>
      <div className={styles.pokerChipBackground}>
        <div className={styles.container} style={{ backgroundImage: `url(${bgImage})` }}>
          <div className={styles.spadeOuter}>
            {isFlameVariantEnabled ? (
              <div className={styles.countInner}>
                <PopularBetBuilderCount count={popularBetBuilderCount} />
              </div>
            ) : (
              <div className={styles.spadeInner}>
                <Spade />
              </div>
            )}
          </div>
        </div>
      </div>
    </CardHeader>
  );
};

export default PokerChipHeader;
